// The opening of a match of Godsmode: one beat for each side, before the
// first roll. A beat names the casters of the side and marks the pieces that
// carry them. Added 2026-10-13. Garrett: "I hit random and it just blitzed me
// into the game, needs to set the board and then start rolling die. Not take
// forever but should walk the user in smoothly". Until then the die rolled the
// moment the caster select closed, and a player who pressed Random did not see
// which casters the draw gave.
// The roll for energy waits for a quiet board, so it follows the two beats
// with no rule of its own.

import { OPENING_BEAT_MS } from '../constants';
import { OWNER_NAMES } from '../engine/describe';
import { otherSide } from '../engine/pieces';
import type { Side } from '../engine/types';
import { castersOf } from '../game/casters';
import type { GameState } from '../game/state';
import { type BeatMark, beat, queueBeat } from './director';
import { localSide } from './localSide';

/** Plain words, not final copy. */
const OPENING_DETAIL = 'The marked pieces carry them.';
const openingCaption = (side: Side, names: readonly string[]): string =>
  `${OWNER_NAMES[side]} has ${names.join(' and ')}`;

const carrierMarks = (state: GameState, side: Side): BeatMark[] =>
  state.board.flatMap((piece, square) =>
    piece && piece.owner === side && piece.casterId !== null
      ? [{ square, kind: 'pick' as const }]
      : [],
  );

/** Queues the beats of the opening. The player first, then the other side. */
export const queueOpening = (state: GameState): void => {
  if (state.mode !== 'gods') return;
  const sides: Side[] = [localSide(), otherSide(localSide())];
  for (const side of sides) {
    const names = castersOf(state, side).map((caster) => caster.name);
    if (names.length === 0) continue;
    queueBeat(
      beat(openingCaption(side, names), OPENING_DETAIL, {
        marks: carrierMarks(state, side),
        tone: 'system',
        spotlight: true,
      }),
      OPENING_BEAT_MS,
    );
  }
};
